<template>
    <div class="card-container">
        <div class="header-container">
            <span class="header-title">{{ headerTitle }}</span>
            <slot name="header-append" />
            <img :src="closeIcon" alt="close" class="close-icon" v-on:click="this.cancel" />
        </div>
        <div class="card-body">
            <div
                :class="{ noPaddingTop: noPaddingTop, 'fixed-content': fixedSize }"
                :style="{ maxHeight: contentMaxHeight }"
                class="card-content-container"
            >
                <slot />
            </div>
            <BottomNavigation
                v-if="!withoutBotNav"
                :cancel="cancel"
                :confirm="confirm"
                :confirmButtonDisabled="!activeValidate"
                :first="true"
                :last="true"
                :smallMarginRight="true"
                class="bottom-nav"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BottomNavigation from '../layout/BottomNavigation.vue';

export default defineComponent({
    components: { BottomNavigation },
    props: {
        headerTitle: { type: String, required: true },
        activeValidate: { type: Boolean, required: true },
        withoutBotNav: { type: Boolean, required: false },
        noPaddingTop: { type: Boolean, required: false },
        fixedSize: { type: Boolean, required: false },
        maxWidth: { type: String, required: false, default: '60%' },
        width: { type: String, required: false, default: undefined },
        minWidth: { type: String, required: false, default: undefined },
        height: { type: String, required: false },
        contentMaxHeight: { type: String, required: false, default: '60vh' },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-white.svg');
        },
    },
});
</script>

<style scoped>
.card-container {
    border-radius: 4px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    max-width: v-bind(maxWidth);
    width: v-bind(width);
    min-width: v-bind(minWidth);
}
.card-body {
    overflow: hidden;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.card-content-container {
    padding: 16px;
    background-color: var(--white);
    overflow: auto;
    max-height: v-bind(contentMaxHeight);
    height: v-bind(height);
}
.header-container {
    position: relative;
    padding: 12px 24px;
    background-color: var(--bleu-prinicipal);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}
.header-title {
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-large);
    color: var(--white);
}
.bottom-nav {
    position: relative;
    height: 55px;
    z-index: 999;
}
.noPaddingTop {
    padding-top: 0;
}
.close-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
}
.fixed-content {
    height: 50vh;
    width: 50vw;
    border: 16px solid white;
    padding: unset;
    overflow: hidden;
}
</style>
